import React from "react";
// import { TableDatabase } from "../../components";
import { RiAdminFill } from "react-icons/ri";
// import { Spinner } from "react-rainbow-components";
import CreateAdminModal from "../../components/databaseAdminComponent/CreateAdminModal";
import useDatabaseAdminPage from "./useDatabaseAdminPage";
import { columns } from "./conversDataToTableRow";
import {
  ButtonContainer,
  ButtonCreateAdmin,
  Container,
  ContainerSearce,
  ContainerTable,
  CustomTable,
  HeaderContainer,
  HeaderTitle,
  SearchInput,
} from "./index.style";
import { IAdminDetail } from "../../interfaces/admin";
// import { Table } from "antd";

export default function DatabaseCustomerPage() {
  const {
    setSearchKey,
    setCreateAdminModal,
    isLoading,
    data,
    fetchData,
    createAdminModal,
  } = useDatabaseAdminPage();

  return (
    <Container>
      <HeaderContainer>
        <HeaderTitle>
          <RiAdminFill size="2rem" />
          <h1>ฐานข้อมูลผู้ดูแล</h1>
        </HeaderTitle>
        <ContainerSearce>
          <p>ค้นหา</p>
          <SearchInput
            placeholder="ชื่อ / ชื่อไลน์ / เบอร์โทร / อีเมล์"
            onChange={(event) => setSearchKey(event.target.value)}
          />
        </ContainerSearce>
      </HeaderContainer>
      <ButtonContainer>
        <ButtonCreateAdmin onClick={() => setCreateAdminModal(true)}>
          เพิ่ม Admin +
        </ButtonCreateAdmin>
      </ButtonContainer>
      <ContainerTable>
        {/* {isLoading ? (
          <Spinner size="large" variant="brand" />
        ) : (
          <>
            <TableDatabase
            header={["ชื่อหมอ", "เบอร์โทร", "อีเมล", "Role"]}
            tableRows={conversDataToTableRows(data)}
          />

          </>
        )} */}
        <CustomTable
          columns={columns}
          rowKey={(record: IAdminDetail) => record.uid + record.email}
          dataSource={data}
          bordered
          loading={isLoading}
          pagination={{
            pageSize: 5,
          }}
        />
      </ContainerTable>
      <CreateAdminModal
        fetchData={fetchData}
        isOpen={createAdminModal}
        setIsOpen={setCreateAdminModal}
      />
    </Container>
  );
}
